// generated from 966 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastReceivedAnyCampaignFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_received_any_campaign_filter"),
  comparison_key: z.enum([
    "6", // 775 (80.23%)
    "3", // 67 (6.94%)
    "5", // 66 (6.83%)
    "4", // 58 (6.00%)
  ]),
  display_name: z.string(),
  // undefined: 233 (24.12%), defined 733 (75.88%)
  raw_value: z
    .union([
      // number samples: 632 (86.22%)
      // integer: 433 (68.51%)
      // avg: 20.90, min: 0, max: 1456
      z.number().min(0),
      // string samples: 101 (13.78%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 833 (86.23%)
    // integer: 544 (65.31%)
    // avg: 25.29, min: 0, max: 1456
    z.number().min(0),
    // string samples: 133 (13.77%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
